var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('keep-alive',[(_vm.vanOffline.state == 'home')?_c('VanOffline'):_vm._e(),(_vm.vanOffline.state == 'detail')?_c('QrVanOffline'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }